(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strendy-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__strendyHG)return;window.__strendyHG=true;

  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover=window.matchMedia&&window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function qs(r,s){return r.querySelector(s)}
  function qsa(r,s){return Array.prototype.slice.call(r.querySelectorAll(s))}
  function el(tag,cls,txt){var e=document.createElement(tag);if(cls)e.className=cls;if(txt)e.textContent=txt;return e}
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}

  /* ---------- Fullscreen lightbox (pinch / double-tap / wheel / pan / swipe) ---------- */
  var LB=null;
  function lbBuild(){
    if(LB)return LB;
    var root=el('div','shg-lb');root.hidden=true;
    root.setAttribute('role','dialog');root.setAttribute('aria-modal','true');
    var stage=el('div','shg-lb-stage');
    var img=el('img','shg-lb-img');img.alt='';img.draggable=false;
    stage.appendChild(img);
    var bx=el('button','shg-lb-x','\u00d7');bx.type='button';bx.setAttribute('aria-label','Close');
    var bp=el('button','shg-lb-p','\u2039');bp.type='button';bp.setAttribute('aria-label','Previous');
    var bn=el('button','shg-lb-n','\u203a');bn.type='button';bn.setAttribute('aria-label','Next');
    var bc=el('div','shg-lb-c');
    root.appendChild(stage);root.appendChild(bx);root.appendChild(bp);root.appendChild(bn);root.appendChild(bc);
    document.body.appendChild(root);

    var S={root:root,list:[],i:0,s:1,x:0,y:0,zs:2.5};
    var ptrs={},startDist=0,startScale=1,pan0=null,swipe0=0,lastTap=0,lastBodyOverflow='';

    function apply(){img.style.transform='translate('+S.x+'px,'+S.y+'px) scale('+S.s+')'}
    function clampPan(){
      var w=img.offsetWidth*S.s,h=img.offsetHeight*S.s,vw=stage.clientWidth,vh=stage.clientHeight;
      var mx=Math.max(0,(w-vw)/2),my=Math.max(0,(h-vh)/2);
      S.x=clamp(S.x,-mx,mx);S.y=clamp(S.y,-my,my);
    }
    function reset(){S.s=1;S.x=0;S.y=0;apply()}
    function show(i){
      S.i=(i+S.list.length)%S.list.length;
      reset();img.src=S.list[S.i];
      bc.textContent=(S.i+1)+' / '+S.list.length;
      var many=S.list.length>1;
      bp.style.display=many?'':'none';bn.style.display=many?'':'none';bc.style.display=many?'':'none';
    }
    function nav(d){show(S.i+d)}
    function dist(){var k=Object.keys(ptrs);if(k.length<2)return 1;var a=ptrs[k[0]],b=ptrs[k[1]];return Math.sqrt(Math.pow(a.x-b.x,2)+Math.pow(a.y-b.y,2))||1}
    function toggleZoom(cx,cy){
      if(S.s>1){reset();return}
      var r=stage.getBoundingClientRect();
      S.s=S.zs;S.x=-(S.s-1)*(cx-r.left-r.width/2);S.y=-(S.s-1)*(cy-r.top-r.height/2);
      clampPan();apply();
    }
    function onKey(e){
      if(root.hidden)return;
      if(e.key==='Escape')S.close();
      else if(e.key==='ArrowRight')nav(1);
      else if(e.key==='ArrowLeft')nav(-1);
    }

    stage.addEventListener('pointerdown',function(e){
      try{stage.setPointerCapture(e.pointerId)}catch(err){}
      ptrs[e.pointerId]={x:e.clientX,y:e.clientY};
      var ids=Object.keys(ptrs);
      if(ids.length===2){startDist=dist();startScale=S.s;pan0=null}
      else{
        pan0={x:e.clientX,y:e.clientY,ox:S.x,oy:S.y};swipe0=e.clientX;
        var t=Date.now();
        if(t-lastTap<300){toggleZoom(e.clientX,e.clientY);lastTap=0}else{lastTap=t}
      }
    });
    stage.addEventListener('pointermove',function(e){
      if(!ptrs[e.pointerId])return;
      ptrs[e.pointerId]={x:e.clientX,y:e.clientY};
      var ids=Object.keys(ptrs);
      if(ids.length>=2){
        S.s=clamp(startScale*dist()/startDist,1,5);clampPan();apply();
      }else if(pan0&&S.s>1){
        S.x=pan0.ox+(e.clientX-pan0.x);S.y=pan0.oy+(e.clientY-pan0.y);clampPan();apply();
      }
    });
    function up(e){
      var had=!!ptrs[e.pointerId];
      delete ptrs[e.pointerId];
      if(!had)return;
      if(Object.keys(ptrs).length===0){
        if(S.s<1.05){
          var dx=e.clientX-swipe0;
          reset();
          if(Math.abs(dx)>70&&S.list.length>1)nav(dx<0?1:-1);
        }
        pan0=null;
      }
    }
    stage.addEventListener('pointerup',up);
    stage.addEventListener('pointercancel',up);
    stage.addEventListener('wheel',function(e){
      e.preventDefault();
      S.s=clamp(S.s*(e.deltaY<0?1.15:0.87),1,5);clampPan();apply();
    },{passive:false});
    bx.addEventListener('click',function(){S.close()});
    bp.addEventListener('click',function(){nav(-1)});
    bn.addEventListener('click',function(){nav(1)});
    document.addEventListener('keydown',onKey);

    S.open=function(list,i,zs,bg,ui){
      S.list=list;S.zs=zs||2.5;
      root.style.background=bg||'#000';
      root.style.color=ui||'#fff';
      lastBodyOverflow=document.body.style.overflow;
      document.body.style.overflow='hidden';
      root.hidden=false;show(i);bx.focus();
    };
    S.close=function(){root.hidden=true;document.body.style.overflow=lastBodyOverflow;img.removeAttribute('src')};
    LB=S;return S;
  }

  /* ---------- Gallery ---------- */
  function init(root){
    if(root.__hg)return;root.__hg=true;
    var stage=qs(root,'.shg-stage'),track=qs(root,'.shg-track');
    if(!track)return;
    var all=qsa(track,'.shg-slide').sort(function(a,b){return (+a.dataset.rank)-(+b.dataset.rank)});
    if(!all.length)return;
    all.forEach(function(s){track.appendChild(s)});
    var cfg=root.dataset;
    var slides=all.slice(),n=all.length,idx=0,curColor='';
    var dotsEls=qsa(root,'.shg-dots'),thumbsEl=qs(root,'.shg-thumbs');
    var dots=[],thumbs=[],counters=[];
    var loop=cfg.loop==='true';
    var prev=qs(root,'.shg-prev'),next=qs(root,'.shg-next');

    function goTo(i,instant){
      if(i<0)i=loop?n-1:0;
      if(i>=n)i=loop?0:n-1;
      track.scrollTo({left:slides[i].offsetLeft,behavior:(instant||reduced)?'auto':'smooth'});
      if(instant)setActive(i);
    }

    function buildUI(){
      dots=[];thumbs=[];counters=[];
      dotsEls.forEach(function(d){
        while(d.firstChild)d.removeChild(d.firstChild);
        if(n<2){d.style.display='none';return}
        d.style.display='';
        if(cfg.dots==='counter'){var c=el('span','');d.appendChild(c);counters.push(c)}
        else{
          for(var i=0;i<n;i++){
            (function(i){
              var b=el('button','shg-dot');b.type='button';b.setAttribute('aria-label','Go to slide '+(i+1));
              b.addEventListener('click',function(){goTo(i)});
              d.appendChild(b);dots.push(b);
            })(i);
          }
        }
      });
      if(thumbsEl){
        while(thumbsEl.firstChild)thumbsEl.removeChild(thumbsEl.firstChild);
        if(n<2){thumbsEl.style.display='none'}
        else{
          thumbsEl.style.display='';
          slides.forEach(function(sl,i){
            var b=el('button','shg-thumb');b.type='button';b.setAttribute('aria-label','Show slide '+(i+1));
            if(sl.dataset.thumb){var im=el('img');im.src=sl.dataset.thumb;im.alt='';im.width=64;im.height=64;im.loading='lazy';b.appendChild(im)}
            b.addEventListener('click',function(){goTo(i)});
            thumbsEl.appendChild(b);thumbs.push(b);
          });
        }
      }
      if(prev)prev.style.display=n<2?'none':'';
      if(next)next.style.display=n<2?'none':'';
    }

    if(prev)prev.addEventListener('click',function(){goTo(idx-1)});
    if(next)next.addEventListener('click',function(){goTo(idx+1)});
    track.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){e.preventDefault();goTo(idx+1)}
      else if(e.key==='ArrowLeft'){e.preventDefault();goTo(idx-1)}
    });

    /* videos */
    function stopEmbed(sl){
      var f=qs(sl,'.shg-iframe');
      if(f){f.parentNode.removeChild(f)}
      sl.classList.remove('is-playing');
    }
    all.forEach(function(sl){
      var vid=qs(sl,'.shg-vid');
      if(vid){
        var pp=qs(sl,'.shg-pp'),snd=qs(sl,'.shg-snd');
        var sync=function(){if(pp)pp.classList.toggle('is-playing',!vid.paused);if(snd)snd.classList.toggle('is-on',!vid.muted)};
        vid.addEventListener('play',sync);vid.addEventListener('pause',sync);vid.addEventListener('volumechange',sync);
        if(pp)pp.addEventListener('click',function(){if(vid.paused){vid.play()}else{vid.pause()}});
        if(snd)snd.addEventListener('click',function(){vid.muted=!vid.muted;if(!vid.muted&&vid.paused)vid.play()});
        sync();
      }
      var pl=qs(sl,'.shg-play');
      if(pl)pl.addEventListener('click',function(){
        var f=document.createElement('iframe');
        f.className='shg-iframe';f.src=pl.dataset.embed;
        f.setAttribute('allow','autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen','');f.setAttribute('title','Product video');
        sl.appendChild(f);sl.classList.add('is-playing');
      });
    });

    function setActive(i){
      idx=i;
      var cur=slides[i];
      var t=cur?cur.dataset.type:'image';
      stage.setAttribute('data-type',t==='image'?'image':(t==='video'?'video':'embed'));
      all.forEach(function(sl){
        var on=sl===cur;
        sl.classList.toggle('is-active',on);
        var vid=qs(sl,'.shg-vid');
        if(vid){
          if(on&&cfg.videoAutoplay==='true'&&!reduced){var p=vid.play();if(p&&p.catch)p.catch(function(){})}
          else if(!on){vid.pause()}
        }
        if(!on){
          if(sl.__resetZoom)sl.__resetZoom();
          if(qs(sl,'.shg-iframe'))stopEmbed(sl);
        }
      });
      dots.forEach(function(d,k){d.classList.toggle('is-on',k===i)});
      counters.forEach(function(c){c.textContent=(i+1)+' / '+n});
      thumbs.forEach(function(th,k){
        th.classList.toggle('is-on',k===i);
        if(k===i&&thumbsEl){thumbsEl.scrollTo({left:th.offsetLeft-thumbsEl.clientWidth/2+th.clientWidth/2,behavior:'smooth'})}
      });
    }

    /* show only the selected colour's slides */
    function applyColor(color){
      curColor=color||'';
      var list=all.filter(function(s){return !curColor||!s.dataset.color||s.dataset.color===curColor});
      slides=list.length?list:all.slice();
      n=slides.length;
      all.forEach(function(s){s.classList.toggle('is-off',slides.indexOf(s)===-1)});
      buildUI();
      track.scrollLeft=0;
      setActive(0);
    }

    var raf=0;
    track.addEventListener('scroll',function(){
      if(raf)return;
      raf=requestAnimationFrame(function(){
        raf=0;
        var sl=track.scrollLeft,best=0,bd=1e9;
        for(var k=0;k<n;k++){var d=Math.abs(slides[k].offsetLeft-sl);if(d<bd){bd=d;best=k}}
        if(sl+track.clientWidth>=track.scrollWidth-2)best=n-1;
        if(best!==idx)setActive(best);
      });
    },{passive:true});

    /* ---- zoom: in-place (double tap / double click) ---- */
    function setupInplace(){
      var zs=parseFloat(cfg.zoomScale)||2.5;
      all.forEach(function(sl){
        if(sl.dataset.type!=='image')return;
        var img=qs(sl,'.shg-img');if(!img)return;
        var z={s:1,x:0,y:0},pan=null,lastT=0,lastX=0,lastY=0;
        function apply(){img.style.transform=z.s>1?'translate('+z.x+'px,'+z.y+'px) scale('+z.s+')':''}
        function clampZ(){var mx=(z.s-1)*sl.clientWidth/2,my=(z.s-1)*sl.clientHeight/2;z.x=clamp(z.x,-mx,mx);z.y=clamp(z.y,-my,my)}
        function reset(){z={s:1,x:0,y:0};apply();sl.classList.remove('is-zoomed');root.classList.remove('is-zooming')}
        function toggle(cx,cy){
          if(z.s>1){reset();return}
          var r=sl.getBoundingClientRect();
          z.s=zs;z.x=-(zs-1)*(cx-r.left-r.width/2);z.y=-(zs-1)*(cy-r.top-r.height/2);
          clampZ();apply();sl.classList.add('is-zoomed');root.classList.add('is-zooming');
        }
        sl.__resetZoom=reset;
        sl.addEventListener('dblclick',function(e){e.preventDefault();toggle(e.clientX,e.clientY)});
        sl.addEventListener('pointerdown',function(e){
          if(z.s>1){pan={x:e.clientX,y:e.clientY,ox:z.x,oy:z.y};try{sl.setPointerCapture(e.pointerId)}catch(err){}}
        });
        sl.addEventListener('pointermove',function(e){
          if(pan&&z.s>1){z.x=pan.ox+(e.clientX-pan.x);z.y=pan.oy+(e.clientY-pan.y);clampZ();apply()}
        });
        sl.addEventListener('pointerup',function(e){
          pan=null;
          if(e.pointerType!=='touch')return;
          var t=Date.now();
          if(t-lastT<300&&Math.abs(e.clientX-lastX)<30&&Math.abs(e.clientY-lastY)<30){toggle(e.clientX,e.clientY);lastT=0}
          else{lastT=t;lastX=e.clientX;lastY=e.clientY}
        });
        sl.addEventListener('pointercancel',function(){pan=null});
      });
    }

    /* ---- zoom: hover (desktop) ---- */
    function setupHover(){
      if(!canHover)return;
      all.forEach(function(sl){
        if(sl.dataset.type!=='image')return;
        var img=qs(sl,'.shg-img');if(!img)return;
        sl.addEventListener('mousemove',function(e){
          var r=sl.getBoundingClientRect();
          img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
          sl.classList.add('hz');
        });
        sl.addEventListener('mouseleave',function(){sl.classList.remove('hz')});
      });
    }

    /* ---- zoom: magnifier lens (desktop) ---- */
    function setupLens(){
      if(!canHover)return;
      var L=parseInt(cfg.lens,10)||160,zs=parseFloat(cfg.zoomScale)||2.5;
      var lens=el('div','shg-lens');stage.appendChild(lens);
      all.forEach(function(sl){
        if(sl.dataset.type!=='image')return;
        var img=qs(sl,'.shg-img');if(!img)return;
        sl.addEventListener('mousemove',function(e){
          var r=sl.getBoundingClientRect(),w=r.width,h=r.height;
          var nw=img.naturalWidth||w,nh=img.naturalHeight||h;
          var k=cfg.fit==='contain'?Math.min(w/nw,h/nh):Math.max(w/nw,h/nh);
          var dw=nw*k,dh=nh*k,ox=(w-dw)/2,oy=(h-dh)/2;
          var x=e.clientX-r.left,y=e.clientY-r.top;
          lens.style.backgroundImage='url("'+sl.dataset.zoom+'")';
          lens.style.backgroundSize=(dw*zs)+'px '+(dh*zs)+'px';
          lens.style.backgroundPosition=(-((x-ox)*zs-L/2))+'px '+(-((y-oy)*zs-L/2))+'px';
          var sr=stage.getBoundingClientRect();
          lens.style.left=(e.clientX-sr.left-L/2)+'px';
          lens.style.top=(e.clientY-sr.top-L/2)+'px';
          lens.classList.add('on');
        });
        sl.addEventListener('mouseleave',function(){lens.classList.remove('on')});
      });
    }

    if(cfg.zoom==='inplace')setupInplace();
    else if(cfg.zoom==='hover')setupHover();
    else if(cfg.zoom==='lens')setupLens();

    /* ---- fullscreen viewer ---- */
    function openLB(){
      var list=[],start=0;
      slides.forEach(function(sl,k){
        if(sl.dataset.type==='image'&&sl.dataset.zoom){
          if(k===idx)start=list.length;
          list.push(sl.dataset.zoom);
        }
      });
      if(!list.length)return;
      lbBuild().open(list,start,parseFloat(cfg.zoomScale)||2.5,cfg.lbBg,cfg.lbUi);
    }
    var fs=qs(root,'.shg-fs');
    if(fs)fs.addEventListener('click',openLB);
    if(cfg.lbTap==='true'&&cfg.zoom!=='inplace'){
      all.forEach(function(sl){
        if(sl.dataset.type!=='image')return;
        sl.style.cursor='zoom-in';
        sl.addEventListener('click',openLB);
      });
    }

    /* ---- autoplay ---- */
    var ap=parseInt(cfg.autoplay,10)||0,timer=null;
    function stopAP(){ap=0;if(timer){clearInterval(timer);timer=null}}
    if(ap&&!reduced){
      timer=setInterval(function(){
        if(n<2||document.hidden||root.classList.contains('is-zooming'))return;
        var cur=slides[idx];
        var vid=qs(cur,'.shg-vid');
        if((vid&&!vid.paused)||qs(cur,'.shg-iframe'))return;
        goTo(idx+1);
      },ap*1000);
      ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){track.addEventListener(ev,stopAP,{passive:true})});
    }

    /* ---- variant / colour sync ---- */
    var mediaOf={},colorOf={};
    if(cfg.vmap){cfg.vmap.split(',').forEach(function(p){var a=p.split(':');if(a.length===2)mediaOf[a[0]]=a[1]})}
    if(cfg.vcolor){
      cfg.vcolor.split(';').forEach(function(p){
        var i=p.indexOf('=');
        if(i>0){try{colorOf[p.slice(0,i)]=decodeURIComponent(p.slice(i+1))}catch(e){colorOf[p.slice(0,i)]=p.slice(i+1)}}
      });
    }
    function jumpToVariantImage(id,instant){
      var m=mediaOf[id];if(!m)return;
      for(var k=0;k<n;k++){if(slides[k].dataset.mediaId===m){if(k!==idx||instant)goTo(k,instant);return}}
    }
    var lastV=cfg.selVariant||null;
    function onVariant(id){
      if(!id||id===lastV)return;
      lastV=id;
      var col=colorOf[id];
      if(col!==undefined&&col!==curColor){applyColor(col);jumpToVariantImage(id,true)}
      else if(cfg.variantSync==='true'){jumpToVariantImage(id,false)}
    }
    document.addEventListener('change',function(e){
      var t=e.target;
      if(t&&t.name==='id'&&t.value)onVariant(t.value);
    });
    setInterval(function(){
      var inp=document.querySelector('form[action*="/cart/add"] [name="id"]');
      var q=new URLSearchParams(window.location.search).get('variant');
      if(q)onVariant(q);
      else if(inp&&inp.value)onVariant(inp.value);
    },600);

    /* ---- start ---- */
    applyColor(cfg.selColor);
    if(cfg.variantSync==='true'&&cfg.selVariant)jumpToVariantImage(cfg.selVariant,true);
  }

  function boot(){qsa(document,'.shg').forEach(init)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strendy-hero-gallerry"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__strendyHG)return;window.__strendyHG=true;

  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover=window.matchMedia&&window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function qs(r,s){return r.querySelector(s)}
  function qsa(r,s){return Array.prototype.slice.call(r.querySelectorAll(s))}
  function el(tag,cls,txt){var e=document.createElement(tag);if(cls)e.className=cls;if(txt)e.textContent=txt;return e}
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}

  /* ---------- Fullscreen lightbox (pinch / double-tap / wheel / pan / swipe) ---------- */
  var LB=null;
  function lbBuild(){
    if(LB)return LB;
    var root=el('div','shg-lb');root.hidden=true;
    root.setAttribute('role','dialog');root.setAttribute('aria-modal','true');
    var stage=el('div','shg-lb-stage');
    var img=el('img','shg-lb-img');img.alt='';img.draggable=false;
    stage.appendChild(img);
    var bx=el('button','shg-lb-x','\u00d7');bx.type='button';bx.setAttribute('aria-label','Close');
    var bp=el('button','shg-lb-p','\u2039');bp.type='button';bp.setAttribute('aria-label','Previous');
    var bn=el('button','shg-lb-n','\u203a');bn.type='button';bn.setAttribute('aria-label','Next');
    var bc=el('div','shg-lb-c');
    root.appendChild(stage);root.appendChild(bx);root.appendChild(bp);root.appendChild(bn);root.appendChild(bc);
    document.body.appendChild(root);

    var S={root:root,list:[],i:0,s:1,x:0,y:0,zs:2.5};
    var ptrs={},startDist=0,startScale=1,pan0=null,swipe0=0,lastTap=0,lastBodyOverflow='';

    function apply(){img.style.transform='translate('+S.x+'px,'+S.y+'px) scale('+S.s+')'}
    function clampPan(){
      var w=img.offsetWidth*S.s,h=img.offsetHeight*S.s,vw=stage.clientWidth,vh=stage.clientHeight;
      var mx=Math.max(0,(w-vw)/2),my=Math.max(0,(h-vh)/2);
      S.x=clamp(S.x,-mx,mx);S.y=clamp(S.y,-my,my);
    }
    function reset(){S.s=1;S.x=0;S.y=0;apply()}
    function show(i){
      S.i=(i+S.list.length)%S.list.length;
      reset();img.src=S.list[S.i];
      bc.textContent=(S.i+1)+' / '+S.list.length;
      var many=S.list.length>1;
      bp.style.display=many?'':'none';bn.style.display=many?'':'none';bc.style.display=many?'':'none';
    }
    function nav(d){show(S.i+d)}
    function dist(){var k=Object.keys(ptrs);if(k.length<2)return 1;var a=ptrs[k[0]],b=ptrs[k[1]];return Math.sqrt(Math.pow(a.x-b.x,2)+Math.pow(a.y-b.y,2))||1}
    function toggleZoom(cx,cy){
      if(S.s>1){reset();return}
      var r=stage.getBoundingClientRect();
      S.s=S.zs;S.x=-(S.s-1)*(cx-r.left-r.width/2);S.y=-(S.s-1)*(cy-r.top-r.height/2);
      clampPan();apply();
    }
    function onKey(e){
      if(root.hidden)return;
      if(e.key==='Escape')S.close();
      else if(e.key==='ArrowRight')nav(1);
      else if(e.key==='ArrowLeft')nav(-1);
    }

    stage.addEventListener('pointerdown',function(e){
      try{stage.setPointerCapture(e.pointerId)}catch(err){}
      ptrs[e.pointerId]={x:e.clientX,y:e.clientY};
      var ids=Object.keys(ptrs);
      if(ids.length===2){startDist=dist();startScale=S.s;pan0=null}
      else{
        pan0={x:e.clientX,y:e.clientY,ox:S.x,oy:S.y};swipe0=e.clientX;
        var t=Date.now();
        if(t-lastTap<300){toggleZoom(e.clientX,e.clientY);lastTap=0}else{lastTap=t}
      }
    });
    stage.addEventListener('pointermove',function(e){
      if(!ptrs[e.pointerId])return;
      ptrs[e.pointerId]={x:e.clientX,y:e.clientY};
      var ids=Object.keys(ptrs);
      if(ids.length>=2){
        S.s=clamp(startScale*dist()/startDist,1,5);clampPan();apply();
      }else if(pan0&&S.s>1){
        S.x=pan0.ox+(e.clientX-pan0.x);S.y=pan0.oy+(e.clientY-pan0.y);clampPan();apply();
      }
    });
    function up(e){
      var had=!!ptrs[e.pointerId];
      delete ptrs[e.pointerId];
      if(!had)return;
      if(Object.keys(ptrs).length===0){
        if(S.s<1.05){
          var dx=e.clientX-swipe0;
          reset();
          if(Math.abs(dx)>70&&S.list.length>1)nav(dx<0?1:-1);
        }
        pan0=null;
      }
    }
    stage.addEventListener('pointerup',up);
    stage.addEventListener('pointercancel',up);
    stage.addEventListener('wheel',function(e){
      e.preventDefault();
      S.s=clamp(S.s*(e.deltaY<0?1.15:0.87),1,5);clampPan();apply();
    },{passive:false});
    bx.addEventListener('click',function(){S.close()});
    bp.addEventListener('click',function(){nav(-1)});
    bn.addEventListener('click',function(){nav(1)});
    document.addEventListener('keydown',onKey);

    S.open=function(list,i,zs,bg,ui){
      S.list=list;S.zs=zs||2.5;
      root.style.background=bg||'#000';
      root.style.color=ui||'#fff';
      lastBodyOverflow=document.body.style.overflow;
      document.body.style.overflow='hidden';
      root.hidden=false;show(i);bx.focus();
    };
    S.close=function(){root.hidden=true;document.body.style.overflow=lastBodyOverflow;img.removeAttribute('src')};
    LB=S;return S;
  }

  /* ---------- Gallery ---------- */
  function init(root){
    if(root.__hg)return;root.__hg=true;
    var stage=qs(root,'.shg-stage'),track=qs(root,'.shg-track');
    if(!track)return;
    var all=qsa(track,'.shg-slide').sort(function(a,b){return (+a.dataset.rank)-(+b.dataset.rank)});
    if(!all.length)return;
    all.forEach(function(s){track.appendChild(s)});
    var cfg=root.dataset;
    var slides=all.slice(),n=all.length,idx=0,curColor='';
    var dotsEls=qsa(root,'.shg-dots'),thumbsEl=qs(root,'.shg-thumbs');
    var dots=[],thumbs=[],counters=[];
    var loop=cfg.loop==='true';
    var prev=qs(root,'.shg-prev'),next=qs(root,'.shg-next');

    function goTo(i,instant){
      if(i<0)i=loop?n-1:0;
      if(i>=n)i=loop?0:n-1;
      track.scrollTo({left:slides[i].offsetLeft,behavior:(instant||reduced)?'auto':'smooth'});
      if(instant)setActive(i);
    }

    function buildUI(){
      dots=[];thumbs=[];counters=[];
      dotsEls.forEach(function(d){
        while(d.firstChild)d.removeChild(d.firstChild);
        if(n<2){d.style.display='none';return}
        d.style.display='';
        if(cfg.dots==='counter'){var c=el('span','');d.appendChild(c);counters.push(c)}
        else{
          for(var i=0;i<n;i++){
            (function(i){
              var b=el('button','shg-dot');b.type='button';b.setAttribute('aria-label','Go to slide '+(i+1));
              b.addEventListener('click',function(){goTo(i)});
              d.appendChild(b);dots.push(b);
            })(i);
          }
        }
      });
      if(thumbsEl){
        while(thumbsEl.firstChild)thumbsEl.removeChild(thumbsEl.firstChild);
        if(n<2){thumbsEl.style.display='none'}
        else{
          thumbsEl.style.display='';
          slides.forEach(function(sl,i){
            var b=el('button','shg-thumb');b.type='button';b.setAttribute('aria-label','Show slide '+(i+1));
            if(sl.dataset.thumb){var im=el('img');im.src=sl.dataset.thumb;im.alt='';im.width=64;im.height=64;im.loading='lazy';b.appendChild(im)}
            b.addEventListener('click',function(){goTo(i)});
            thumbsEl.appendChild(b);thumbs.push(b);
          });
        }
      }
      if(prev)prev.style.display=n<2?'none':'';
      if(next)next.style.display=n<2?'none':'';
    }

    if(prev)prev.addEventListener('click',function(){goTo(idx-1)});
    if(next)next.addEventListener('click',function(){goTo(idx+1)});
    track.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){e.preventDefault();goTo(idx+1)}
      else if(e.key==='ArrowLeft'){e.preventDefault();goTo(idx-1)}
    });

    /* videos */
    function stopEmbed(sl){
      var f=qs(sl,'.shg-iframe');
      if(f){f.parentNode.removeChild(f)}
      sl.classList.remove('is-playing');
    }
    all.forEach(function(sl){
      var vid=qs(sl,'.shg-vid');
      if(vid){
        var pp=qs(sl,'.shg-pp'),snd=qs(sl,'.shg-snd');
        var sync=function(){if(pp)pp.classList.toggle('is-playing',!vid.paused);if(snd)snd.classList.toggle('is-on',!vid.muted)};
        vid.addEventListener('play',sync);vid.addEventListener('pause',sync);vid.addEventListener('volumechange',sync);
        if(pp)pp.addEventListener('click',function(){if(vid.paused){vid.play()}else{vid.pause()}});
        if(snd)snd.addEventListener('click',function(){vid.muted=!vid.muted;if(!vid.muted&&vid.paused)vid.play()});
        sync();
      }
      var pl=qs(sl,'.shg-play');
      if(pl)pl.addEventListener('click',function(){
        var f=document.createElement('iframe');
        f.className='shg-iframe';f.src=pl.dataset.embed;
        f.setAttribute('allow','autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen','');f.setAttribute('title','Product video');
        sl.appendChild(f);sl.classList.add('is-playing');
      });
    });

    function setActive(i){
      idx=i;
      var cur=slides[i];
      var t=cur?cur.dataset.type:'image';
      stage.setAttribute('data-type',t==='image'?'image':(t==='video'?'video':'embed'));
      all.forEach(function(sl){
        var on=sl===cur;
        sl.classList.toggle('is-active',on);
        var vid=qs(sl,'.shg-vid');
        if(vid){
          if(on&&cfg.videoAutoplay==='true'&&!reduced){var p=vid.play();if(p&&p.catch)p.catch(function(){})}
          else if(!on){vid.pause()}
        }
        if(!on){
          if(sl.__resetZoom)sl.__resetZoom();
          if(qs(sl,'.shg-iframe'))stopEmbed(sl);
        }
      });
      dots.forEach(function(d,k){d.classList.toggle('is-on',k===i)});
      counters.forEach(function(c){c.textContent=(i+1)+' / '+n});
      thumbs.forEach(function(th,k){
        th.classList.toggle('is-on',k===i);
        if(k===i&&thumbsEl){thumbsEl.scrollTo({left:th.offsetLeft-thumbsEl.clientWidth/2+th.clientWidth/2,behavior:'smooth'})}
      });
    }

    /* show only the selected colour's slides */
    function applyColor(color){
      curColor=color||'';
      var list=all.filter(function(s){return !curColor||!s.dataset.color||s.dataset.color===curColor});
      slides=list.length?list:all.slice();
      n=slides.length;
      all.forEach(function(s){s.classList.toggle('is-off',slides.indexOf(s)===-1)});
      buildUI();
      track.scrollLeft=0;
      setActive(0);
    }

    var raf=0;
    track.addEventListener('scroll',function(){
      if(raf)return;
      raf=requestAnimationFrame(function(){
        raf=0;
        var sl=track.scrollLeft,best=0,bd=1e9;
        for(var k=0;k<n;k++){var d=Math.abs(slides[k].offsetLeft-sl);if(d<bd){bd=d;best=k}}
        if(sl+track.clientWidth>=track.scrollWidth-2)best=n-1;
        if(best!==idx)setActive(best);
      });
    },{passive:true});

    /* ---- zoom: in-place (double tap / double click) ---- */
    function setupInplace(){
      var zs=parseFloat(cfg.zoomScale)||2.5;
      all.forEach(function(sl){
        if(sl.dataset.type!=='image')return;
        var img=qs(sl,'.shg-img');if(!img)return;
        var z={s:1,x:0,y:0},pan=null,lastT=0,lastX=0,lastY=0;
        function apply(){img.style.transform=z.s>1?'translate('+z.x+'px,'+z.y+'px) scale('+z.s+')':''}
        function clampZ(){var mx=(z.s-1)*sl.clientWidth/2,my=(z.s-1)*sl.clientHeight/2;z.x=clamp(z.x,-mx,mx);z.y=clamp(z.y,-my,my)}
        function reset(){z={s:1,x:0,y:0};apply();sl.classList.remove('is-zoomed');root.classList.remove('is-zooming')}
        function toggle(cx,cy){
          if(z.s>1){reset();return}
          var r=sl.getBoundingClientRect();
          z.s=zs;z.x=-(zs-1)*(cx-r.left-r.width/2);z.y=-(zs-1)*(cy-r.top-r.height/2);
          clampZ();apply();sl.classList.add('is-zoomed');root.classList.add('is-zooming');
        }
        sl.__resetZoom=reset;
        sl.addEventListener('dblclick',function(e){e.preventDefault();toggle(e.clientX,e.clientY)});
        sl.addEventListener('pointerdown',function(e){
          if(z.s>1){pan={x:e.clientX,y:e.clientY,ox:z.x,oy:z.y};try{sl.setPointerCapture(e.pointerId)}catch(err){}}
        });
        sl.addEventListener('pointermove',function(e){
          if(pan&&z.s>1){z.x=pan.ox+(e.clientX-pan.x);z.y=pan.oy+(e.clientY-pan.y);clampZ();apply()}
        });
        sl.addEventListener('pointerup',function(e){
          pan=null;
          if(e.pointerType!=='touch')return;
          var t=Date.now();
          if(t-lastT<300&&Math.abs(e.clientX-lastX)<30&&Math.abs(e.clientY-lastY)<30){toggle(e.clientX,e.clientY);lastT=0}
          else{lastT=t;lastX=e.clientX;lastY=e.clientY}
        });
        sl.addEventListener('pointercancel',function(){pan=null});
      });
    }

    /* ---- zoom: hover (desktop) ---- */
    function setupHover(){
      if(!canHover)return;
      all.forEach(function(sl){
        if(sl.dataset.type!=='image')return;
        var img=qs(sl,'.shg-img');if(!img)return;
        sl.addEventListener('mousemove',function(e){
          var r=sl.getBoundingClientRect();
          img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
          sl.classList.add('hz');
        });
        sl.addEventListener('mouseleave',function(){sl.classList.remove('hz')});
      });
    }

    /* ---- zoom: magnifier lens (desktop) ---- */
    function setupLens(){
      if(!canHover)return;
      var L=parseInt(cfg.lens,10)||160,zs=parseFloat(cfg.zoomScale)||2.5;
      var lens=el('div','shg-lens');stage.appendChild(lens);
      all.forEach(function(sl){
        if(sl.dataset.type!=='image')return;
        var img=qs(sl,'.shg-img');if(!img)return;
        sl.addEventListener('mousemove',function(e){
          var r=sl.getBoundingClientRect(),w=r.width,h=r.height;
          var nw=img.naturalWidth||w,nh=img.naturalHeight||h;
          var k=cfg.fit==='contain'?Math.min(w/nw,h/nh):Math.max(w/nw,h/nh);
          var dw=nw*k,dh=nh*k,ox=(w-dw)/2,oy=(h-dh)/2;
          var x=e.clientX-r.left,y=e.clientY-r.top;
          lens.style.backgroundImage='url("'+sl.dataset.zoom+'")';
          lens.style.backgroundSize=(dw*zs)+'px '+(dh*zs)+'px';
          lens.style.backgroundPosition=(-((x-ox)*zs-L/2))+'px '+(-((y-oy)*zs-L/2))+'px';
          var sr=stage.getBoundingClientRect();
          lens.style.left=(e.clientX-sr.left-L/2)+'px';
          lens.style.top=(e.clientY-sr.top-L/2)+'px';
          lens.classList.add('on');
        });
        sl.addEventListener('mouseleave',function(){lens.classList.remove('on')});
      });
    }

    if(cfg.zoom==='inplace')setupInplace();
    else if(cfg.zoom==='hover')setupHover();
    else if(cfg.zoom==='lens')setupLens();

    /* ---- fullscreen viewer ---- */
    function openLB(){
      var list=[],start=0;
      slides.forEach(function(sl,k){
        if(sl.dataset.type==='image'&&sl.dataset.zoom){
          if(k===idx)start=list.length;
          list.push(sl.dataset.zoom);
        }
      });
      if(!list.length)return;
      lbBuild().open(list,start,parseFloat(cfg.zoomScale)||2.5,cfg.lbBg,cfg.lbUi);
    }
    var fs=qs(root,'.shg-fs');
    if(fs)fs.addEventListener('click',openLB);
    if(cfg.lbTap==='true'&&cfg.zoom!=='inplace'){
      all.forEach(function(sl){
        if(sl.dataset.type!=='image')return;
        sl.style.cursor='zoom-in';
        sl.addEventListener('click',openLB);
      });
    }

    /* ---- autoplay ---- */
    var ap=parseInt(cfg.autoplay,10)||0,timer=null;
    function stopAP(){ap=0;if(timer){clearInterval(timer);timer=null}}
    if(ap&&!reduced){
      timer=setInterval(function(){
        if(n<2||document.hidden||root.classList.contains('is-zooming'))return;
        var cur=slides[idx];
        var vid=qs(cur,'.shg-vid');
        if((vid&&!vid.paused)||qs(cur,'.shg-iframe'))return;
        goTo(idx+1);
      },ap*1000);
      ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){track.addEventListener(ev,stopAP,{passive:true})});
    }

    /* ---- variant / colour sync ---- */
    var mediaOf={},colorOf={};
    if(cfg.vmap){cfg.vmap.split(',').forEach(function(p){var a=p.split(':');if(a.length===2)mediaOf[a[0]]=a[1]})}
    if(cfg.vcolor){
      cfg.vcolor.split(';').forEach(function(p){
        var i=p.indexOf('=');
        if(i>0){try{colorOf[p.slice(0,i)]=decodeURIComponent(p.slice(i+1))}catch(e){colorOf[p.slice(0,i)]=p.slice(i+1)}}
      });
    }
    function jumpToVariantImage(id,instant){
      var m=mediaOf[id];if(!m)return;
      for(var k=0;k<n;k++){if(slides[k].dataset.mediaId===m){if(k!==idx||instant)goTo(k,instant);return}}
    }
    var lastV=cfg.selVariant||null;
    function onVariant(id){
      if(!id||id===lastV)return;
      lastV=id;
      var col=colorOf[id];
      if(col!==undefined&&col!==curColor){applyColor(col);jumpToVariantImage(id,true)}
      else if(cfg.variantSync==='true'){jumpToVariantImage(id,false)}
    }
    document.addEventListener('change',function(e){
      var t=e.target;
      if(t&&t.name==='id'&&t.value)onVariant(t.value);
    });
    setInterval(function(){
      var inp=document.querySelector('form[action*="/cart/add"] [name="id"]');
      var q=new URLSearchParams(window.location.search).get('variant');
      if(q)onVariant(q);
      else if(inp&&inp.value)onVariant(inp.value);
    },600);

    /* ---- start ---- */
    applyColor(cfg.selColor);
    if(cfg.variantSync==='true'&&cfg.selVariant)jumpToVariantImage(cfg.selVariant,true);
  }

  function boot(){qsa(document,'.shg').forEach(init)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strendy-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__strendySB3)return;window.__strendySB3=true;

  function visible(el){return !!(el&&(el.offsetWidth||el.offsetHeight||el.getClientRects().length))}

  function findByText(bar,re){
    var nodes=document.querySelectorAll('button,a,input[type="submit"],[role="button"]');
    for(var i=0;i<nodes.length;i++){
      var n=nodes[i];
      if(bar.contains(n))continue;
      var t=(n.value||n.textContent||'').replace(/\s+/g,' ').trim();
      if(t.length<40&&re.test(t)&&visible(n))return n;
    }
    return null;
  }

  function target(bar,kind){
    var sel=bar.dataset[kind==='atc'?'atcSelector':'buySelector'];
    if(sel){try{var el=document.querySelector(sel);if(el)return el}catch(e){}}
    return findByText(bar,kind==='atc'?/add to (cart|bag)/i:/buy (it )?now/i);
  }

  function variantId(bar){
    var inp=document.querySelector('form[action*="/cart/add"] [name="id"]');
    if(inp&&inp.value)return inp.value;
    var q=new URLSearchParams(window.location.search).get('variant');
    return q||bar.dataset.variant;
  }

  function setBadge(bar,n){
    var b=bar.querySelector('.sb-badge');
    if(!b)return;
    b.textContent=n;b.hidden=!(n>0);
  }
  function refreshBadge(bar){
    if(!bar.querySelector('.sb-badge'))return;
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()}).then(function(c){setBadge(bar,c.item_count)}).catch(function(){});
  }

  function fallbackAdd(bar,goCheckout){
    var id=variantId(bar);
    bar.classList.add('is-busy');
    var body={id:id,quantity:1};
    var drawer=document.querySelector('cart-drawer');
    if(!goCheckout&&drawer){body.sections='cart-drawer,cart-icon-bubble';body.sections_url=window.location.pathname}
    return fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)
    }).then(function(r){return r.json()}).then(function(data){
      if(data.status){throw new Error(data.description||'add failed')}
      if(goCheckout){window.location.href='/checkout';return}
      refreshBadge(bar);
      if(drawer&&drawer.renderContents){drawer.renderContents(data)}
      else{window.location.href=bar.dataset.cartUrl||'/cart'}
    }).catch(function(){window.location.href=bar.dataset.cartUrl||'/cart'})
      .then(function(){bar.classList.remove('is-busy')});
  }

  function floatEl(bar){
    var sel=bar.dataset.liftSelector;
    if(sel){try{var e=document.querySelector(sel);if(e)return e}catch(x){}}
    var a=document.querySelector('a[href*="wa.me"],a[href*="api.whatsapp.com"],a[href*="whatsapp.com/send"]');
    if(!a)return null;
    var n=a;
    while(n&&n!==document.body){
      if(window.getComputedStyle(n).position==='fixed')return n;
      n=n.parentElement;
    }
    return a;
  }

  function pad(n){return n<10?'0'+n:''+n}
  function initTimer(of){
    var t=of.querySelector('.sb-timer');
    if(!t)return;
    var prefix=of.dataset.timerPrefix||'';
    function tick(){
      var now=new Date(),end=new Date(now);end.setHours(23,59,59,999);
      var s=Math.max(0,Math.floor((end-now)/1000));
      t.textContent=(prefix?prefix+' ':'')+pad(Math.floor(s/3600))+':'+pad(Math.floor(s%3600/60))+':'+pad(s%60);
    }
    tick();setInterval(tick,1000);
  }

  function initOffer(bar){
    var of=bar.querySelector('.sb-offer');
    if(!of)return;
    initTimer(of);
    var x=of.querySelector('.sb-x');
    if(x){
      try{if(sessionStorage.getItem('strendy_offer_x')){of.style.display='none'}}catch(e){}
      x.addEventListener('click',function(e){
        e.stopPropagation();of.style.display='none';
        try{sessionStorage.setItem('strendy_offer_x','1')}catch(err){}
      });
    }
    var code=of.dataset.code;
    if(code&&of.classList.contains('is-copy')){
      of.addEventListener('click',function(){
        var done=function(){
          var r=of.querySelector('.sb-or:not(.sb-timer)')||of.querySelector('.sb-ol');
          if(!r)return;
          var old=r.textContent;r.textContent=of.dataset.copied||'Copied!';
          setTimeout(function(){r.textContent=old},1600);
        };
        if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(code).then(done,done)}
        else{var t=document.createElement('textarea');t.value=code;document.body.appendChild(t);t.select();try{document.execCommand('copy')}catch(e){}document.body.removeChild(t);done()}
      });
    }
  }

  function init(bar){
    if(bar.__init)return;bar.__init=true;
    var mode=bar.dataset.mode;
    var atcBtn=bar.querySelector('[data-sb="atc"]'),buyBtn=bar.querySelector('[data-sb="buy"]');
    var haptic=bar.dataset.haptic==='true';
    function buzz(){if(haptic&&navigator.vibrate){try{navigator.vibrate(12)}catch(e){}}}

    if(atcBtn)atcBtn.addEventListener('click',function(){
      buzz();
      var t=target(bar,'atc');
      if(t){t.click();setTimeout(function(){refreshBadge(bar)},1400)}else{fallbackAdd(bar,false)}
      if(bar.dataset.added==='true'){
        atcBtn.classList.add('is-added');
        setTimeout(function(){atcBtn.classList.remove('is-added')},1400);
      }
    });
    if(buyBtn)buyBtn.addEventListener('click',function(){
      buzz();
      var t=target(bar,'buy');
      if(t){t.click()}else{fallbackAdd(bar,true)}
    });
    initOffer(bar);
    refreshBadge(bar);

    var fl=null;
    function apply(on){
      var isDesktop=window.matchMedia('(min-width:750px)').matches;
      document.body.style.paddingBottom=(on&&!isDesktop)?bar.offsetHeight+'px':'';
      if(bar.dataset.lift==='true'){
        if(!fl)fl=floatEl(bar);
        if(fl){
          if(on){fl.style.setProperty('bottom',(bar.offsetHeight+(bar.classList.contains('is-float')?24:14))+'px','important')}
          else{fl.style.removeProperty('bottom')}
        }
      }
    }
    function show(on){bar.classList.toggle('is-visible',on);apply(on)}

    if(mode==='always'){show(true);return}

    var watched=null,io=null;
    function watch(){
      var t=target(bar,'atc')||target(bar,'buy');
      if(!t)return false;
      if(t===watched)return true;
      watched=t;
      if(io)io.disconnect();
      io=new IntersectionObserver(function(entries){
        var e=entries[0];
        show(!e.isIntersecting&&e.boundingClientRect.top<0);
      },{threshold:0});
      io.observe(t);
      return true;
    }
    if(!watch()){
      var tries=0,iv=setInterval(function(){
        tries++;
        if(watch()){clearInterval(iv);return}
        if(tries>10){
          clearInterval(iv);
          var px=parseInt(bar.dataset.scrollPx,10)||600;
          window.addEventListener('scroll',function(){show(window.scrollY>px)},{passive:true});
        }
      },700);
    }
  }

  function boot(){document.querySelectorAll('.strendy-sb').forEach(init)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
